// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xs_a bhy_vp bhy_vh bhy_xe bhy_rg bhy_tr bhy_qx"};